<template>
  <div>
    <customer-report-add
      :is-active="isModalActive"
      :customer-id="Number(this.$route.params.id)"
      :is-add="isAdd"
      :action="action"
      :edit-object-name="editObjectName"
      @confirm="editConfirm"
      @cancel="editCancel"
    />
    <circul8-table
      :records="data"
      :fields="columns"
      :defaultSortColumn="country"
      :routeNext="false"
      :usePropRecords="true"
      @clickcheck="checkCheckBox"
      @clickEdit="editModal"
      @clickView="viewModal"
      @clickDelete="deleteModal"
      :showRemoveButton="showDelete"
      :showEditButton="showEdit"
      :tableHeight="tableHeight"
      :maxTextLength="'40'"
      :isCheckable="false"
      :isLoading="isDataLoading"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { forkJoin } from "rxjs";
import { Permission } from "../../services/Permissions";
import Circul8Table from "../../components/Circul8Table.vue";
import CustomerReportAdd from "@/components/Customers/CustomerReportAdd";
import utilityMixin from "@/mixins/UtilityMixin";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import ScopeMixin from "@/mixins/scopeMixin";
// @group Customers
export default {
  name: "CustomerReportsView",
  mixins: [utilityMixin, ScopeMixin],
  components: {
    Circul8Table,
    CustomerReportAdd
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    contactAction: {
      type: Boolean,
      default: false
    },
    country: {
      type: String,
      default: "false"
    },
    customerAccountManager: {
      type: Number,
      default: 0
    },
    backupCustomerAccountManager: {
      type: Number,
      default: 0
    },
    countryMaps: {}
  },
  data() {
    return {
      isAdd: false,
      action: null,
      isDataLoading: true,
      clickView: true,
      clickEdit: true,
      clickDelete: true,
      isModalActive: false,
      showRemoveButton: true,

      linkEdit: "reportingtracker.customerUpdateEdit",
      linkViewEdit: "reportingtracker.customerUpdateEdit",

      editObject: this.getClearFormObject(),

      customerDataService: new CustomerProfileDataService(),
      data: [],
      checkedRows: [],
      tableHeight: "",
      columns: [
        {
          field: "customerId",
          label: "Customer"
        },
        {
          field: "country",
          label: "Country"
        },
        {
          field: "stream",
          label: "Stream"
        },
        {
          field: "report_type",
          label: "Report Type",
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "additional_info",
          uriLink: true
        },

        {
          field: "scheme",
          label: "Scheme"
        },
        {
          field: "frequency",
          label: "Frequency"
        },
        {
          field: "valid_from",
          label: "Valid From"
        },
        {
          field: "valid_to",
          label: "Valid To"
        },

        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),

    editObjectName() {
      return this.editObject || this.getClearFormObject();
    }
  },
  watch: {
    customerAccountManager(newValue) {
      this.fetchCustomerReports();
    }
  },
  mounted() {
    this.fetchContainers();
    //this.fetchCountries();
    this.fetchSchemes();
    forkJoin(this.fetchCustomerList()).subscribe(parents => {
      this.fetchCustomerReports();
    });
  },
  methods: {
    checkCheckBox(d) {
      this.checkedRows = d;
    },
    getClearFormObject() {
      return {
        id: null,
        customer: null,
        country: null,
        scheme: null,
        stream: null,
        report: null,
        valid_from: null,
        valid_to: null,
        frequency: null,
        additional_info: null
      };
    },
    addModal() {
      this.isAdd = true;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      editObject["valid_from_date"] = this.convertToDate(editObject.valid_from);
      editObject["valid_to_date"] = this.convertToDate(editObject.valid_to);
      this.isAdd = true;
      this.action = "Edit";
      this.editObject = editObject;

      this.isModalActive = true;
    },
    deleteModal(editObject) {
      editObject["valid_from_date"] = this.convertToDate(editObject.valid_from);
      editObject["valid_to_date"] = this.convertToDate(editObject.valid_to);
      this.isAdd = true;
      this.action = "Delete";
      this.editObject = editObject;

      this.isModalActive = true;
    },
    viewModal(editObject) {
      editObject["valid_from_date"] = this.convertToDate(editObject.valid_from);
      editObject["valid_to_date"] = this.convertToDate(editObject.valid_to);
      this.isAdd = true;
      this.action = "View";
      this.editObject = editObject;

      this.isModalActive = true;
    },
    editConfirm() {
      this.isModalActive = false;
      this.fetchCustomerReports();
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },

    prepareData(data) {
      for (const report in data) {
        data[report]["actions"] = false;
      }
      this.data = data;
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    fetchCustomerReports() {
      this.isDataLoading = true;
      const reportsObserve = this.customerDataService.getCustomerReports(
        this.$route.params.id
      );
      reportsObserve.subscribe(
        response => {
          this.prepareCustomerReports(response);
          this.isDataLoading = false;
        },
        e => {
          console.log(e);
        }
      );
      return reportsObserve;
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt == " - ") {
        return newDate;
      }
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    dateFormating(dt) {
      let newDate = " - ";
      if (dt == null) {
        return newDate;
      }
      dt = new Date(dt);
      newDate =
        dt.getFullYear() +
        "-" +
        ("0" + (dt.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + dt.getDate()).slice(-2);

      return newDate;
    },

    fetchCustomerList() {
      const customerObserve = this.customerDataService.getCustomerList(
        this.$route.params.id
      );
      customerObserve.subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
          this.customerMap = this.prepareMasterData(this.customers);
        },
        e => {
          console.log(e);
        }
      );
      return customerObserve;
    },
    prepareCustomerReports(dataList) {
      const reportDataList = [];
      for (const index in dataList) {
        const data = dataList[index];
        data["active"] = !data["outdated_report"];
        data["valid_from"] = this.convertToDate(data["valid_from"]);
        data["valid_to"] = this.convertToDate(data["valid_to"]);
        if (data["valid_from"] == null && data["valid_to"] == "2099-12-31") {
          data["valid_to"] = null;
        }
        data["scheme_id"] = data["scheme"];
        data["scheme"] = this.schemeMap[data["scheme"]];

        data["country_id"] = data["country"];
        data["country"] = this.countryMaps[data["country"]];

        data["stream_id"] = data["stream"];
        data["stream"] = this.containerMap[data["stream"]];

        data["customerId"] = this.customerMap[data["customer"]];

        data["valid_to"] = this.dateFormating(data["valid_to"]);
        data["valid_from"] = this.dateFormating(data["valid_from"]);
        data["actions"] = this.isEditAllowed(data.customer);
        data["delete"] = this.isEditAllowed(data.customer);

        reportDataList.push(data);
      }
      this.reports = reportDataList;
      reportDataList.sort(this.fieldSorter(["country"]));
      this.data = reportDataList;

      if (this.data.length > 8) {
        this.tableHeight = "height:600px";
      }
    },

    isEditAllowed(data) {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          (this.customerAccountManager == this.userId ||
            this.backupCustomerAccountManager == this.userId))
      ) {
        this.showDelete = true;
        this.showEdit = true;
        return true;
      } else {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
    },
    fieldSorter(fields) {
      return function(a, b) {
        return fields
          .map(function(o) {
            let dir = 1;
            if (o[0] === "-") {
              dir = -1;
              o = o.substring(1);
            }
            if (a[o] > b[o]) return dir;
            if (a[o] < b[o]) return -dir;
            return 0;
          })
          .reduce(function firstNonZeroValue(p, n) {
            return p ? p : n;
          }, 0);
      };
    }
  }
};
</script>
